var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3476_2005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM11.99 10H11C10.7451 10.0003 10.5 10.0979 10.3146 10.2728C10.1293 10.4478 10.0178 10.687 10.0028 10.9414C9.98789 11.1958 10.0707 11.4464 10.2343 11.6418C10.3979 11.8373 10.6299 11.9629 10.883 11.993L11 12V16.99C11 17.51 11.394 17.94 11.9 17.994L12.01 18H12.5C12.7103 18 12.9153 17.9337 13.0857 17.8105C13.2562 17.6873 13.3835 17.5135 13.4495 17.3139C13.5155 17.1142 13.5169 16.8988 13.4534 16.6982C13.3899 16.4977 13.2649 16.3223 13.096 16.197L13 16.134V11.01C13 10.49 12.606 10.06 12.1 10.006L11.99 10ZM12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289C11.1054 7.48043 11 7.73478 11 8C11 8.26522 11.1054 8.51957 11.2929 8.70711C11.4804 8.89464 11.7348 9 12 9C12.2652 9 12.5196 8.89464 12.7071 8.70711C12.8946 8.51957 13 8.26522 13 8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3476_2005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightInfo);
export default __webpack_public_path__ + "static/media/light-info.f3d849c8f0bf77ba03c0d47602619308.svg";
export { ForwardRef as ReactComponent };